import { render, staticRenderFns } from "./Violation.vue?vue&type=template&id=6b9f67bd"
import script from "./Violation.vue?vue&type=script&lang=js"
export * from "./Violation.vue?vue&type=script&lang=js"
import style0 from "./Violation.vue?vue&type=style&index=0&id=6b9f67bd&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports